export const formatDateToDDMMYYYY = (dateString: string | number | Date): any => {
    if (!dateString) return "N/A";
  
    try {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-GB').format(date); // 'en-GB' gives DD/MM/YYYY
    } catch (error) {
      return "Invalid Date";
    }
  }